<div class="tw-gap-6 tw-flex tw-flex-col">
  @if (processingTrial()) {
    <app-loading-overlay></app-loading-overlay>
  }

  <!--      switch button (hidden in 'Your Bundle' view)-->
  @if (!isYourBundleView()) {
    <div
      class="tw-flex tw-relative tw-w-full tw-justify-center tw-items-center tw-p-1 tw-rounded-2xl tw-bg-dt-surface-page"
    >
      <!-- Animated background slider -->
      <div
        class="tw-absolute tw-top-1 tw-bottom-1 tw-rounded-2xl tw-bg-color-surface-elevated border-gradient-neuomorphic tw-transition-all tw-duration-300 tw-ease-in-out"
        [ngStyle]="{
          left: selectedBillingCycle() === 'annual' ? '4px' : 'calc(60% + 4px)',
          right: selectedBillingCycle() === 'annual' ? 'auto' : '4px',
          width: selectedBillingCycle() === 'annual' ? 'calc(60% - 8px)' : 'calc(40% - 8px)',
        }"
      ></div>

      <!--       annual-->
      <div
        class="tw-relative tw-z-10 tw-flex tw-flex-[1.5] tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-py-2 tw-rounded-2xl tw-cursor-pointer tw-transition-colors tw-duration-300"
        (click)="selectBillingCycle('annual')"
      >
        <span
          class="tw-font-medium tw-text-[14px] tw-leading-[125%] tw-tracking-[0.4%] tw-transition-colors tw-duration-300"
          [ngClass]="
            selectedBillingCycle() === 'annual'
              ? 'tw-text-dt-text-headings'
              : 'tw-text-dt-text-secondary'
          "
          >Annual</span
        >
        <div class="tw-rounded-[60px] tw-bg-dt-surface-in tw-py-1.5 tw-px-3">
          <span
            class="tw-text-dt-text-in-primary tw-font-medium tw-leading-[125%] tw-tracking-[0.4%] tw-whitespace-nowrap"
            >Save {{ planOptions.premiumAnnual.youSave }}</span
          >
        </div>
      </div>
      <!--       monthly-->
      <div
        class="tw-relative tw-z-10 tw-flex tw-flex-1 tw-h-full tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-py-2 tw-rounded-2xl tw-cursor-pointer tw-transition-colors tw-duration-300"
        (click)="selectBillingCycle('monthly')"
      >
        <span
          class="tw-text-[14px] tw-leading-[125%] tw-tracking-[1.25%] tw-transition-colors tw-duration-300"
          [ngClass]="
            selectedBillingCycle() === 'monthly'
              ? 'tw-font-medium tw-text-dt-text-headings'
              : 'tw-text-dt-text-secondary'
          "
          >Monthly
        </span>
      </div>
    </div>
  }

  <!--  price-->
  <div class="tw-flex tw-flex-col tw-w-full tw-items-center tw-justify-center tw-gap-4">
    <!-- Price slider container -->
    <div class="tw-w-full tw-relative tw-overflow-hidden">
      <div
        class="tw-flex tw-w-[200%] tw-transition-transform tw-duration-500 tw-ease-in-out"
        [ngStyle]="{
          transform: selectedBillingCycle() === 'annual' ? 'translateX(0)' : 'translateX(-50%)',
        }"
      >
        <!-- Annual Price -->
        <div class="tw-w-1/2 tw-flex tw-flex-col tw-gap-1 tw-justify-center tw-items-center">
          <div class="tw-flex tw-gap-1 tw-items-baseline">
            <span
              class="tw-text-[36px] tw-leading-[125%] tw-tracking-normal tw-font-semibold tw-text-dt-text-action"
              >{{ planOptions.premiumAnnual.feeAmount }}</span
            >
            <span
              class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
              >{{ planOptions.premiumAnnual.paymentCycle }}</span
            >
          </div>
          <span
            class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
          >
            ≈ {{ monthlyEquivalent() }}/month, billed annually
          </span>
        </div>

        <!-- Monthly Price -->
        <div class="tw-w-1/2 tw-flex tw-flex-col tw-gap-1 tw-justify-center tw-items-center">
          <div class="tw-flex tw-gap-1 tw-items-baseline">
            <span
              class="tw-text-[36px] tw-leading-[24px] tw-tracking-normal tw-font-semibold tw-text-dt-text-action"
              >{{ planOptions.premiumMonthly.feeAmount }}</span
            >
            <span
              class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
              >{{ planOptions.premiumMonthly.paymentCycle }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!--    description-->
    <div
      class="tw-rounded-[60px] tw-bg-dt-surface-in tw-py-1.5 tw-px-3 tw-border tw-border-dt-border-in"
    >
      <span
        class="tw-text-dt-text-in-primary tw-text-[14px] tw-font-medium tw-leading-[125%] tw-tracking-[0.4%] tw-whitespace-nowrap"
        >{{ trialDays }}-day free trial included</span
      >
    </div>
  </div>

  <!--  Subscription info section (trial/billing) - only in 'Your Bundle' view -->
  @if (isYourBundleView()) {
    <div
      class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-p-4 tw-rounded-2xl tw-shadow-elevation-card"
    >
      <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
        @if (isInTrialPeriod()) {
          <div class="tw-flex tw-gap-2 tw-w-full">
            <icon [size]="8" [name]="'bell-primary'"></icon>
            <div class="tw-flex tw-flex-col tw-gap-1">
              <span
                class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
                >Trial ends in
                <span class="tw-text-dt-text-action tw-font-bold">{{
                  trialRemainingDays() ?? 0
                }}</span>
                days</span
              >
              <span
                class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary tw-w-fit"
                >We'll notify you 3 days before billing.</span
              >
            </div>
          </div>
          <div class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-color-border-subtle"></div>
        }
        <div class="tw-flex tw-gap-2 tw-w-full">
          <icon [size]="8" [name]="'calendar'" [currentColor]="'primary'"></icon>
          <div class="tw-flex tw-flex-col tw-gap-1">
            <span
              class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
              >Next billing date</span
            >
            <span
              class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
              >{{ formattedBillingDate() }}</span
            >
          </div>
        </div>
      </div>
    </div>
  }

  <!--  PLUGINS INCLUDED section-->
  <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
    <div class="tw-flex tw-w-full tw-justify-between tw-items-center">
      <span
        class="tw-text-[14px] tw-font-semibold tw-leading-[125%] tw-tracking-[0.4%] tw-text-dt-text-secondary"
        >PLUGINS INCLUDED</span
      >
      <div
        class="tw-flex tw-justify-center tw-items-center tw-py-2 tw-px-5 border-gradient-neuomorphic tw-rounded-xl"
      >
        <span
          class="tw-text-dt-text-secondary tw-text-[14px] tw-font-medium tw-leading-[125%] tw-tracking-[0.4%] tw-underline"
          >{{ includedPlugins.length }}</span
        >
      </div>
    </div>
    <div
      class="tw-flex tw-flex-col tw-w-full tw-rounded-2xl tw-shadow-elevation-card tw-px-4 tw-py-3 tw-gap-4"
    >
      @for (plugin of includedPlugins; track plugin.name; let first = $first) {
        @if (!first) {
          <div class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-color-border-subtle"></div>
        }
        <div class="tw-flex tw-gap-4 tw-w-full">
          <div
            class="tw-flex tw-flex-shrink-0 tw-rounded-xl tw-items-center tw-justify-center tw-w-[48px] tw-h-[48px]"
            [ngClass]="plugin.iconBgClass"
          >
            <icon [name]="plugin.icon" [size]="6"></icon>
          </div>
          <div class="tw-flex tw-flex-col tw-w-full tw-gap-1">
            <div class="tw-flex tw-gap-2 tw-items-center">
              <span
                class="tw-font-medium tw-text-[16px] tw-leading-[24px] tw-tracking-normal tw-text-dt-text-headings"
                >{{ plugin.name }}</span
              >
              <span
                class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
                >{{ plugin.by }}</span
              >
            </div>
            <div class="tw-flex tw-w-full tw-items-center">
              <span
                class="tw-text-[13px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-secondary"
                >{{ plugin.description }}</span
              >
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!--  payment method section (hidden in 'Your Bundle' view and when it's the current bundle)-->
  @if (!isYourBundleView() && !isSelectedCycleCurrentBundle() && !isApple) {
    <div class="tw-flex tw-flex-col tw-gap-2">
      <span
        class="tw-text-[14px] tw-font-semibold tw-leading-[125%] tw-tracking-[0.4%] tw-text-dt-text-secondary"
        >PAYMENT METHOD</span
      >
      <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full sm:tw-gap-6">
        <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-w-full sm:tw-grid-cols-1">
          <ng-container
            *ngTemplateOutlet="
              paymentMethodOption;
              context: {
                method: 'add',
                title: 'Add payment method',
                subtitle: 'Redirects to Stripe',
              }
            "
          ></ng-container>

          <ng-container
            *ngTemplateOutlet="
              paymentMethodOption;
              context: {
                method: 'skip',
                title: 'Skip for now',
                subtitle: 'Add within 14 days',
              }
            "
          ></ng-container>
        </div>

        <div
          class="tw-flex tw-items-center tw-px-4 tw-py-3 tw-gap-4 tw-rounded-2xl tw-bg-dt-surface-page tw-w-full"
        >
          <div
            class="tw-flex tw-flex-shrink-0 tw-rounded-2xl tw-items-center tw-justify-center tw-p-4 tw-shadow-elevation-control"
          >
            <icon [name]="'shield-bundle'" [size]="6"></icon>
          </div>
          <div
            class="tw-flex tw-flex-col tw-gap-1 tw-font-medium tw-text-[14px] tw-tracking-[1%] tw-leading-[125%] tw-text-dt-text-secondary"
          >
            <span class=""
              >Start a
              <span class="tw-font-bold tw-text-dt-text-action"
                >{{ trialDays }}-day free trial</span
              >
              of {{ marketLabel() }}.</span
            >
            <span
              >After trial:
              <span class="tw-text-dt-text-action">{{ afterTrialPriceDisplay() }}</span></span
            >
            <span>We'll notify you before charging.</span>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Footer with buttons -->
  @if (showSwitchButton()) {
    <ng-container
      *ngTemplateOutlet="
        actionButton;
        context: {
          text: isSelectedCycleCurrentBundle()
            ? 'Your Current Bundle'
            : isApple
              ? appleActionText()
              : 'Switch to This Bundle',
          isDisabled: isSelectedCycleCurrentBundle() || (isApple && !canRedeemWithCredits()),
        }
      "
    ></ng-container>
  } @else if (showSubscribeButton()) {
    @if (!isApple || canStartAppleTrial()) {
      <ng-container
        *ngTemplateOutlet="
          actionButton;
          context: {
            text: 'Start ' + trialDays + '-day free trial',
            isDisabled: false,
            trial: isApple,
          }
        "
      ></ng-container>
    }
    @if (isApple) {
      <ng-container
        *ngTemplateOutlet="
          actionButton;
          context: {
            text: appleActionText(),
            isDisabled: !canRedeemWithCredits(),
          }
        "
      ></ng-container>
    }
  } @else if (isYourBundleView()) {
    <!-- Cancel subscription button for 'Your Bundle' view -->
    <div class="tw-flex tw-w-full tw-py-2">
      <button
        class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings tw-underline tw-transition-colors tw-duration-200 hover:tw-text-dt-text-error"
        (click)="handleCancelSubscription()"
      >
        Cancel Subscription
      </button>
    </div>
  }
</div>

<ng-template #confirmationTemplate>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-text-[18px]">You have selected the</div>
    <div class="tw-font-medium tw-text-[24px]">{{ confirmationPlanLabel }}</div>
    <div class="tw-mt-2 tw-text-[18px]">You will be charged</div>
    <div class="tw-font-medium tw-text-[24px] tw-whitespace-nowrap">
      <span class="tw-underline tw-decoration-primary">{{ confirmationBillingAmount }}</span>
      <span>/</span>
      <span>{{ confirmationBillingPeriod }}</span>
    </div>
    <div class="tw-mt-2 tw-text-[18px]">Do you want to proceed?</div>
  </div>
</ng-template>

<ng-template #paymentMethodOption let-method="method" let-title="title" let-subtitle="subtitle">
  <div
    class="tw-flex tw-items-center tw-px-4 tw-py-3 tw-gap-4 tw-rounded-2xl tw-shadow-elevation-control tw-w-full tw-cursor-pointer tw-transition-all tw-border-2 tw-border-transparent tw-duration-300 tw-ease-in-out"
    [ngClass]="{
      ' !tw-border-dt-border-action tw-bg-dt-surface-today-tertiary':
        selectedPaymentMethod() === method,
    }"
    (click)="selectPaymentMethod(method)"
  >
    <div
      class="tw-w-7 tw-h-7 tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[44px] tw-transition-all"
      [ngClass]="{
        'tw-bg-dt-surface-on-action': selectedPaymentMethod() === method,
        'tw-shadow-elevation-input': selectedPaymentMethod() !== method,
      }"
    >
      @if (selectedPaymentMethod() === method) {
        <icon [name]="'check-only'" [size]="6" [currentColor]="'color-text-on-action'"></icon>
      }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-1">
      <span
        class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
        >{{ title }}</span
      >
      <span
        class="tw-text-[12px] tw-tracking-[0.04px] tw-leading-[125%] tw-text-dt-text-headings"
        >{{ subtitle }}</span
      >
    </div>
  </div>
</ng-template>

<ng-template #actionButton let-text="text" let-isDisabled="isDisabled" let-trial="trial">
  <button
    class="tw-flex tw-items-center tw-justify-center tw-py-4 tw-w-full tw-rounded-[50px] tw-transition-all tw-duration-200"
    [ngClass]="{
      'tw-bg-dt-surface-on-action hover:tw-scale-[1.01] active:tw-scale-[0.99] tw-cursor-pointer tw-shadow-elevation-cta-glow':
        !isDisabled,
      'tw-bg-dt-surface-disabled': isDisabled,
    }"
    [disabled]="isDisabled"
    (click)="!isDisabled && (trial ? startAppleTrial() : handleAction())"
  >
    <span
      class="tw-font-medium tw-text-[20px] tw-tracking-[0.5%] tw-leading-[135%]"
      [ngClass]="{
        'tw-text-color-text-on-action': !isDisabled,
        'tw-text-dt-text-disabled': isDisabled,
      }"
      >{{ text }}</span
    >
  </button>
</ng-template>
